// ZoneDev Community's own production instance. This is what makes the app
// treat itself as "home": Instance.ts only drops the `/i/<host>` prefix and
// uses this origin when the current host matches it, which is what keeps
// invite links on https://community.zonedev.com.br/invite/<code> instead of
// pointing them at the upstream Stoat domain.
export const ZONEDEV_HOST = "community.zonedev.com.br";
export const ZONEDEV_API = "https://community.zonedev.com.br/api";

/** App `stoat.json` endpoint format */
export interface AppConfig {
  api: string;
}

/**
 * Fetch env var by name, optionally only when in dev mode.
 * Also prevents compiler from optimizing out injected strings in Docker
 */
const getEnv = (name: string, devOnly?: boolean) =>
  !devOnly || import.meta.env.DEV
    ? (import.meta.env[name] as string)
    : undefined;

const DEFAULT_HOST =
  getEnv("VITE_DEV_HOST", true) || getEnv("VITE_HOST") || ZONEDEV_HOST;

const DEFAULT_API_URL =
  getEnv("VITE_DEV_API_URL", true) || getEnv("VITE_API_URL") || ZONEDEV_API;

if (DEFAULT_API_URL !== ZONEDEV_API && DEFAULT_HOST === ZONEDEV_HOST)
  throw "VITE_HOST required when VITE_API_URL is set!";

export default {
  /** Default instance (without the protocol) */
  DEFAULT_HOST,
  /** API URL of default instance */
  DEFAULT_API_URL,
  /** WS server override for development */
  DEV_WS_URL: getEnv("VITE_DEV_WS_URL"),
  /** Media server override for development */
  DEV_MEDIA_URL: getEnv("VITE_DEV_MEDIA_URL"),
  /** Proxy server override for development */
  DEV_PROXY_URL: getEnv("VITE_DEV_PROXY_URL"),
  /** Gifbox server override for development */
  DEV_GIFBOX_URL: getEnv("VITE_DEV_GIFBOX_URL"),
  /**
   * RNNoise worklet CDN host location. Defaults to blank, which uses the url provided by the livekit-rnnoise-processor package.
   */
  RNNOISE_WORKLET_CDN_URL: getEnv("VITE_RNNOISE_WORKLET_CDN_URL"),
  /**
   * Session ID to set during development.
   */
  DEVELOPMENT_SESSION_ID: getEnv("VITE_SESSION_ID", true),
  /**
   * Token to set during development.
   */
  DEVELOPMENT_TOKEN: getEnv("VITE_TOKEN", true),
  /**
   * User ID to set during development.
   */
  DEVELOPMENT_USER_ID: getEnv("VITE_USER_ID", true),
};
